import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@assets/img/Rolling-loading.svg'


const _withScopeId = (n: any) => (_pushScopeId("data-v-79f45c72"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "user_contacts" }
const _hoisted_2 = { class: "user_title_box" }
const _hoisted_3 = {
  key: 0,
  class: "load-container"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = ["onClick"]
const _hoisted_7 = {
  key: 0,
  class: "info_field"
}
const _hoisted_8 = { class: "info_field" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "№:", -1))
const _hoisted_10 = { class: "info_field" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "EUR:", -1))
const _hoisted_12 = { class: "info_field" }
const _hoisted_13 = /*#__PURE__*/_createStaticVNode("<span class=\"icon_box icon_circle_plus\" data-v-79f45c72><svg class=\"add_contact_icon\" width=\"35px\" height=\"35px\" viewBox=\"0 0 35 35\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" data-v-79f45c72><g id=\"Dashboard-—-Tranfer-—-Account-number\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\" transform=\"translate(-1296.000000, -307.000000)\" data-v-79f45c72><g id=\"Group-8\" transform=\"translate(970.000000, 198.000000)\" data-v-79f45c72><g id=\"Group-9\" transform=\"translate(30.000000, 90.000000)\" data-v-79f45c72><g id=\"add-contact-icon\" transform=\"translate(297.000000, 20.000000)\" data-v-79f45c72><circle id=\"Oval-4\" stroke=\"#CCD0D5\" cx=\"16.5\" cy=\"16.5\" r=\"16.5\" data-v-79f45c72></circle><path d=\"M17,16 L24,16 L24,17 L17,17 L17,24 L16,24 L16,17 L9,17 L9,16 L16,16 L16,9 L17,9 L17,16 Z\" id=\"Combined-Shape\" fill=\"#CCD0D5\" data-v-79f45c72></path></g></g></g></g></svg></span>", 1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h3", null, _toDisplayString(_ctx.$localization.getTranslate("PaymentTemplates")), 1)
    ]),
    (!_ctx.Templates)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, _hoisted_5))
      : _createCommentVNode("", true),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.FilterTemplates, (template) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "contacts_container",
        key: template.CardNumber
      }, [
        _createElementVNode("a", {
          href: "#",
          class: "one_infobox",
          onClick: ($event: any) => (_ctx.UseTemplate(template))
        }, [
          _createElementVNode("h4", null, _toDisplayString(template.Name), 1),
          (_ctx.type == 2 || _ctx.type == 3)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createElementVNode("p", null, _toDisplayString(_ctx.$localization.getTranslate("Name")) + ":", 1),
                _createElementVNode("span", null, _toDisplayString(template.Recipient), 1)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_8, [
            _hoisted_9,
            _createElementVNode("span", null, _toDisplayString(template.CardNumber), 1)
          ]),
          _createElementVNode("div", _hoisted_10, [
            _hoisted_11,
            _createElementVNode("span", null, _toDisplayString(template.Amount), 1)
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("p", null, _toDisplayString(_ctx.$localization.getTranslate("Goal")) + ":", 1),
            _createElementVNode("span", null, _toDisplayString(template.PurposePayment), 1)
          ]),
          _hoisted_13
        ], 8, _hoisted_6)
      ]))
    }), 128))
  ]))
}